export default "__VITE_ASSET__awSHoddJ__"